module.exports = __webpack_public_path__ + "img/p5toptextbg.e247e247.png";